import moment from "moment";

export const getTimeOfDayGreeting = () => {
  const hour = new Date().getHours();

  if (hour < 12) {
    return "Good morning";
  }

  if (hour < 17) {
    return "Good afternoon";
  }

  return "Good evening";
};

export const formatRelativeTimestampProps = (value) => {
  if (!value) {
    return { children: "—" };
  }

  const timestamp = moment(value);
  if (!timestamp.isValid()) {
    return { children: "—" };
  }

  return {
    dateTime: value,
    title: timestamp.format("D MMM YYYY, h:mm a"),
    children: timestamp.fromNow(),
  };
};

export const paPrimaryButtonClass =
  "rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:opacity-50";

export const paSecondaryButtonClass =
  "rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:opacity-50";
